import React, { Component } from 'react';
import './EstruturaInicial.css';
import dimlogo from './exposiesp.png'; 

class EstruturaI1 extends Component {
    render() { 
        return (
            <div className="displayInicial"> {this.props.children}
                <div className="cascataInicial">
                    <div >
                        <img className="logoInicial" src={dimlogo} alt=""/>
                    </div>
                </div>
            </div>
          );
    }
}
 
export default EstruturaI1  ;